(() => {
  let listenersAttached = false;

  function initDiscountScript() {
    const appliedDiscountsContainer = document.getElementById('applied-discounts');
    const applyBtn = document.getElementById('apply-discount-btn');
    const discountInput = document.getElementById('discount-input');

    if (!appliedDiscountsContainer || !applyBtn || !discountInput) return;

    const strings = window.cartDiscountStrings || {};
    const MSG_NO_CODE = strings.errorNoCode || "Please enter a discount code.";
    const MSG_ALREADY_APPLIED = strings.errorAlreadyApplied || "That discount code is already applied.";
    const MSG_INVALID = strings.errorInvalid || "Discount code is invalid or not applicable.";

    function clearMessages() {
      const errDiv = document.getElementById('discount-error-message');
      if (errDiv) {
        errDiv.style.display = 'none';
        errDiv.textContent = '';
      }
    }

    function showError(msg) {
      const errDiv = document.getElementById('discount-error-message');
      if (errDiv) {
        errDiv.style.display = 'block';
        errDiv.textContent = msg;
      }
    }

    function getCurrentDiscounts() {
      const pills = document.querySelectorAll('#applied-discounts .discount-pill');
      return Array.from(pills).map((pill) => pill.getAttribute('data-code').toUpperCase());
    }

    function triggerCartUpdate() {
      const cartDrawerItems = document.querySelector('cart-drawer-items');
      const fakeEvt = { currentTarget: {} };

      if (cartDrawerItems && typeof cartDrawerItems.updateQuantity === 'function') {
        const qtyInput =
          document.getElementById('Drawer-quantity-1') ||
          document.getElementById('Quantity-1');
        if (qtyInput) {
          const currentQty = parseInt(qtyInput.value, 10) || 1;
          cartDrawerItems.updateQuantity(1, currentQty, fakeEvt, null, null);
          return;
        } else {
          cartDrawerItems.onCartUpdate();
          return;
        }
      }

      const cartItems = document.querySelector('cart-items');
      if (cartItems && typeof cartItems.updateQuantity === 'function') {
        const qtyInput =
          document.getElementById('Quantity-1') ||
          document.getElementById('Drawer-quantity-1');
        if (qtyInput) {
          const currentQty = parseInt(qtyInput.value, 10) || 1;
          cartItems.updateQuantity(1, currentQty, fakeEvt, null, null);
          return;
        } else {
          cartItems.onCartUpdate();
          return;
        }
      }
    }

    async function applyDiscounts(discountCodes = []) {
      if (discountCodes.length) {
        const url = `/discount/${encodeURIComponent(discountCodes.join(','))}?redirect=/cart`;
        try {
          await fetch(url, { 
            method: 'GET', 
            mode: 'no-cors', 
            credentials: 'include' 
            });
        } catch (err) {}
      } else {
        const url = `/discount/REMOVE_SHOPIFY_CODE?redirect=/cart`;
        try {
          await fetch(url, { method: 'GET', mode: 'no-cors', credentials: 'include' });
        } catch (_) {}
      }

      const cartRes = await fetch('/cart.js', { credentials: 'include' });
      const cartData = await cartRes.json();

      const validSet = new Set();
      (cartData.cart_level_discount_applications || []).forEach(d => validSet.add(d.title.toUpperCase()));
      cartData.items.forEach(item => {
        (item.line_level_discount_allocations || []).forEach(a => {
          validSet.add(a.discount_application.title.toUpperCase());
        });
      });

      const invalidCodes = discountCodes.filter(c => !validSet.has(c.toUpperCase()));

      if (discountCodes.length === 0 || invalidCodes.length < discountCodes.length) {
        triggerCartUpdate();
      }
      return {
        success: discountCodes.length === 0 || invalidCodes.length < discountCodes.length,
        invalidCodes
      };
    }

    if (!listenersAttached) {
      document.addEventListener('click', async (e) => {
        if (e.target && e.target.id === 'apply-discount-btn') {
          clearMessages();
          const existingCodes = getCurrentDiscounts();
          let newCode = (document.getElementById('discount-input')?.value || '').trim().toUpperCase();
          if (!newCode) {
            showError(MSG_NO_CODE);
            return;
          }
          if (existingCodes.includes(newCode)) {
            showError(MSG_ALREADY_APPLIED);
            return;
          }
          const combinedCodes = [...existingCodes, newCode];
          const result = await applyDiscounts(combinedCodes);
          if (result.invalidCodes.map(c => c.toUpperCase()).includes(newCode)) {
            showError(MSG_INVALID);
          }
        }

        if (e.target && e.target.closest('.remove-discount')) {
          clearMessages();
          const pill = e.target.closest('.discount-pill');
          if (!pill) return;
          const codeToRemove = pill.getAttribute('data-code');
          if (!codeToRemove) return;
          const existingCodes = getCurrentDiscounts();
          const newDiscountList = existingCodes.filter(c => c !== codeToRemove.toUpperCase());
          await applyDiscounts(newDiscountList);
        }
      });
      listenersAttached = true;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    initDiscountScript();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      initDiscountScript();
    });
  }
})();